import {Component, OnInit} from '@angular/core';

import {EnvironmentService} from '../../../service/environment.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {

    public app_name: string;

    constructor(private env: EnvironmentService) {
        this.app_name = env.getAppName();
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/layout/footer/footer.component.ts